import React from 'react'

const Form = props => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Message</label>
                    </div>
                    <div className="form-input">
                        <textarea type="text" name="message" value={props.message} onChange={props.onChange} />
                        <span className="error">{props.errors.message}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="submit">Accept</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default Form